export {default} from './CloseToCompetencySection.connect';
